import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useSession } from '@/app/session';
import { Icon } from '@/design-system';
import s from './PageHeader.module.css';

/**
 * The page header pattern. With an action (or `row`), eyebrow + title sit left and the action right;
 * without one it is the plain title block (Settings, Audit).
 */
export function PageHeader({ eyebrow, title, action, row }: { eyebrow?: ReactNode; title: ReactNode; action?: ReactNode; row?: boolean }) {
  const titles = (
    <div className={s.titles}>
      {eyebrow !== undefined && <span className={s.eyebrow}>{eyebrow}</span>}
      <h1 className={s.h1}>{title}</h1>
    </div>
  );
  if (!action && !row) return titles;
  return (
    <div className={s.row}>
      {titles}
      {action}
    </div>
  );
}

/** «Раздел доступен только Admin»: what a PM sees on Admin-only routes. */
export function NoAccess() {
  const { t } = useTranslation('shell');
  return (
    <div className={s.noAccess} role="alert">
      <Icon name="lock" size={24} className={s.lock} />
      <span className={s.naTitle}>{t('no_access.title')}</span>
      <span className={s.naText}>{t('no_access.text')}</span>
    </div>
  );
}

/** Renders children for Admins and NoAccess for everyone else (the server still enforces RBAC). */
export function AdminOnly({ children }: { children: ReactNode }) {
  const { isAdmin } = useSession();
  return isAdmin ? <>{children}</> : <NoAccess />;
}
